import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

/**
 * MotionCard — premium surface with optional hover lift & entrance fade-up.
 * Use for Dashboard bento, feature grids, etc.
 */
export default function MotionCard({
  className,
  children,
  hoverLift = true,
  delay = 0,
  ...props
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
      whileHover={hoverLift ? { y: -3 } : undefined}
      className={cn(
        "premium-card p-6",
        className,
      )}
      {...props}
    >
      {children}
    </motion.div>
  );
}
